import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import moment from "moment";

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import MenuItem from '@material-ui/core/MenuItem';
import Chip from '@material-ui/core/Chip';


const styles = {
    chip: {
        marginRight: '10px',
    },
    field: {
        padding: '10px',
        backgroundColor: 'rgba(0,0,0,0.1)',
        width: 'calc(100% - 20px)',
        display: 'block',
        marginTop: '10px',
    },
    list: {

    },
    spaceBetween: {
        display: 'flex',
        justifyContent: 'space-between',
        width: 'calc(100% - 50px)',
    },
    status: {
        float: 'right',
    },
    incoming: {
        // color: 'orange',
    },
    inLot: {
        backgroundColor: 'orange',
    },
    finished: {
        backgroundColor: 'green',
    }
};

function formatISK(price) {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

class OrderDetails extends Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        moment.locale('is');
    }

    render() {
        const { classes } = this.props;
        const { order } = this.props;
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.onClose}
                aria-labelledby="form-dialog-title"
            >
                {
                    order &&
                    <form onSubmit={this.onSubmit}>
                        <DialogTitle id="form-dialog-title">
                            {order.vehicle.reg} - {order.client.name}
                            {order.arrived ?
                                order.returned ?
                                    <Chip className={[classes.finished, classes.status]} label='Bókun afgreidd' />
                                    :
                                    <Chip className={[classes.inLot, classes.status]} label='Bíll á plani' />
                                :
                                <Chip className={[classes.incoming, classes.status]} label='Bíll væntanlegur' />

                            }
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Modi error fugit, similique debitis autem quasi magni assumenda tenetur cum accusamus harum libero facilis natus ea nemo saepe ab at? Sapiente.
                            </DialogContentText>
                            <b className={classes.field}>Bókunarupplýsingar</b>
                            <ul className={classes.list}>
                                <li className={classes.spaceBetween}>
                                    <b>Bókunardagssetning</b>
                                    {moment(order.createdAt).format('LLL')}
                                </li>
                                <li className={classes.spaceBetween}>
                                    <b>Upphæð bókunnar</b>
                                    {formatISK(order.totalPrice)} ISK
                                </li>
                                {
                                    order.price &&
                                    <li className={classes.spaceBetween}>
                                        <b>Grunngjald</b>
                                        {formatISK(order.price.base)} ISK
                                    </li>
                                }
                                {
                                    order.price &&
                                    <li className={classes.spaceBetween}>
                                        <b>Geymslugjald</b>
                                        {formatISK(order.price.storage)} ISK
                                    </li>
                                }
                                {
                                    order.price &&
                                    <li className={classes.spaceBetween}>
                                        <b>Önnur þjónusta</b>
                                        {formatISK(order.totalPrice - order.price.storage - order.price.base)} ISK
                                    </li>
                                }

                            </ul>
                            <b className={classes.field}>Ferðaupplýsingar</b>
                            <ul className={classes.list}>
                                <li className={classes.spaceBetween}>
                                    <b>Komutími á leifsstöð</b>
                                    {moment(order.stay.departure).format('LLL')}
                                </li>
                                <li className={classes.spaceBetween}>
                                    <b>Komutími heim</b>
                                    {moment(order.stay.arrival).format('LLL')}
                                </li>
                                <li className={classes.spaceBetween}>
                                    <b>Flugnúmer</b>
                                    {order.stay.flightNumber}
                                </li>
                                <li className={classes.spaceBetween}>
                                    <b>Lengd ferðar</b>
                                    {order.stay.duration}
                                </li>
                            </ul>
                            <b className={classes.field}>Persónuupplýsingar</b>
                            <ul className={classes.list}>
                                <li className={classes.spaceBetween}>
                                    <b>Nafn</b>
                                    {order.client.name}
                                </li>
                                <li className={classes.spaceBetween}>
                                    <b>Kennitala</b>
                                    {order.client.ssn} {order.client.senior && ' 👵 '} {order.client.vip && ' 🏆 '}
                                </li>
                                <li className={classes.spaceBetween}>
                                    <b>Netfang</b>
                                    {order.client.email}
                                </li>
                                <li className={classes.spaceBetween}>
                                    <b>Símanúmer</b>
                                    {order.client.phone}
                                </li>
                            </ul>
                            <b className={classes.field}>Upplýsingar um bifreið</b>
                            <ul className={classes.list}>
                                <li className={classes.spaceBetween}>
                                    <b>Bílnúmer</b>
                                    {order.vehicle.reg}
                                </li>
                                <li className={classes.spaceBetween}>
                                    <b>Gerð</b>
                                    {order.vehicle.make}
                                </li>
                                <li className={classes.spaceBetween}>
                                    <b>Týpa</b>
                                    {order.vehicle.type}
                                </li>
                                <li className={classes.spaceBetween}>
                                    <b>Litur</b>
                                    {order.vehicle.color}
                                </li>
                            </ul>
                            {
                                !!order.services.length &&
                                <div>
                                    <DialogContentText>Þjónustur:</DialogContentText>
                                    {order.services.map(s => <Chip className={classes.chip} label={`${s.labelThen} - ${formatISK(s.priceThen)} kr. ( fullt verð )`} />)}
                                </div>
                            }
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={e => this.props.onClose()} color="primary">
                                Loka
                            </Button>
                            <Button color="primary" type="submit">
                                Breyta
                            </Button>
                        </DialogActions>
                    </form>
                }
            </Dialog>
        )
    }
}

export default withStyles(styles)(OrderDetails);


// WEBPACK FOOTER //
// ./src/views/Orders/OrderDetails.jsx